const postIntent = {
  header: "Help Buoy get smarter",
  timeout: 7000,
}

export { postIntent as default }



// WEBPACK FOOTER //
// ./assets/integration/postIntent.js